<script>
  import {
    availabilityLocationTypes,
    availabilityTotalNights,
    isResolvedAvailabilityData,
  } from './../store/fetchAvailabilityData.js';
  import ListItem from './ListItem.svelte';

  $: sortedStatusAvailableItemsFirst = sortBy(
    $availabilityLocationTypes,
    'Status'
  );

  /**
   * @author Dat Doan
   * @date 2021-04-13
   * @param {array} arr
   * @param {string} key
   * @returns {array}
   */
  const sortBy = (arr, key) =>
    [...arr].sort((a, b) => (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0));
</script>

{#if $isResolvedAvailabilityData && sortedStatusAvailableItemsFirst}
  <div
    class="box-shadow-medium lh-condensed-ultra"
    data-testid="availability-listing-result">
    <div class="Box border-0 rounded-0">
      {#each sortedStatusAvailableItemsFirst as { UnitTypeId, UnitTypeName, Status, Description, BookingUrl, Charges, Total, BusinessCode, ProviderId, BookingMessage } (UnitTypeId)}
        <ListItem
          {UnitTypeName}
          {Status}
          {Description}
          {BookingUrl}
          {Charges}
          {Total}
          TotalNights={$availabilityTotalNights}
          {BusinessCode}
          {ProviderId}
          {BookingMessage} />
      {/each}
    </div>
  </div>
{/if}
